import { INVALID_ERRORS, PaymentFormFieldType, REQUIRED_ERRORS } from '../../internals/UserAddress/constants';
/** hasFormFieldErrors - check if the form has any error
 * @param {ArrayWithStringAsKeys} formFields
 * @returns { ArrayWithStringAsKeys } array of form fields that has error.
 */
export var hasFormFieldErrors = function hasFormFieldErrors(formFields) {
  return Object.keys(formFields).filter(function (k) {
    return formFields[k].error.length;
  }).length > 0;
};

/** setInitialState
 * @param { any } prop
 * @param { any} defaultValue
 * @returns { string } prop if not undefined, otherwise, returns defaultValue
 */
export var setInitialState = function setInitialState(prop, defaultValue) {
  return prop !== undefined ? prop : defaultValue;
};

/** getPaymentFieldLabelText
 * @param { PaymentForm | undefined } paymentForm
 * @param { string } key
 * @returns { string } text of the label of the payment field
 */
export var getPaymentFieldLabelText = function getPaymentFieldLabelText(paymentForm, key) {
  var _paymentForm$type;
  var type = PaymentFormFieldType.FIELD;
  return (paymentForm === null || paymentForm === void 0 || (_paymentForm$type = paymentForm[type]) === null || _paymentForm$type === void 0 || (_paymentForm$type = _paymentForm$type.find(function (field) {
    return field.uniqueId === key;
  })) === null || _paymentForm$type === void 0 ? void 0 : _paymentForm$type.text) || '';
};
export var getPaymentFieldLabelErrorText = function getPaymentFieldLabelErrorText(paymentForm, key) {
  var _paymentForm$type2;
  var type = PaymentFormFieldType.ERROR;
  return (paymentForm === null || paymentForm === void 0 || (_paymentForm$type2 = paymentForm[type]) === null || _paymentForm$type2 === void 0 || (_paymentForm$type2 = _paymentForm$type2.find(function (field) {
    return field.uniqueId === key;
  })) === null || _paymentForm$type2 === void 0 ? void 0 : _paymentForm$type2.text) || '';
};

/** getPaymentFieldErrorText
 * @param { PaymentForm | undefined } paymentForm
 * @param { string | undefined } error
 * @param { string } requiredKey
 * @param { string } invalidKey
 * @returns { string } text of the error of the payment field
 */
export var getPaymentFieldErrorText = function getPaymentFieldErrorText(paymentForm, paymentErrorModal, error, requiredKey, invalidKey
// eslint-disable-next-line max-params
) {
  var type = PaymentFormFieldType.ERROR;
  //  add new along with existing structure support from contentful in payment section
  var fieldErrors = (paymentErrorModal === null || paymentErrorModal === void 0 ? void 0 : paymentErrorModal[type]) || (paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm[type]);
  if (error && INVALID_ERRORS.has(error)) {
    var _fieldErrors$find;
    return (fieldErrors === null || fieldErrors === void 0 || (_fieldErrors$find = fieldErrors.find(function (fieldError) {
      return fieldError.uniqueId === invalidKey;
    })) === null || _fieldErrors$find === void 0 ? void 0 : _fieldErrors$find.text) || '';
  } else if (error && REQUIRED_ERRORS.has(error)) {
    var _fieldErrors$find2;
    return (fieldErrors === null || fieldErrors === void 0 || (_fieldErrors$find2 = fieldErrors.find(function (fieldError) {
      return fieldError.uniqueId === requiredKey;
    })) === null || _fieldErrors$find2 === void 0 ? void 0 : _fieldErrors$find2.text) || '';
  }
  return '';
};
export var getPaymentServerErrorText = function getPaymentServerErrorText(paymentErrorModal, key) {
  var _serverErrors$find;
  var type = PaymentFormFieldType.SERVER_ERROR;
  var serverErrors = paymentErrorModal === null || paymentErrorModal === void 0 ? void 0 : paymentErrorModal[type];
  return (serverErrors === null || serverErrors === void 0 || (_serverErrors$find = serverErrors.find(function (serverError) {
    return serverError.uniqueId === key;
  })) === null || _serverErrors$find === void 0 ? void 0 : _serverErrors$find.text) || '';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentForm/helpers.js
// module id = 105
// module chunks = 11